// import { call, put, takeLatest } from "redux-saga/effects";
// import {
//   fetchRecommendationsStart,
//   fetchRecommendationsSuccess,
//   fetchRecommendationsFailure,
//   fetchPerformanceDataInit,
//   fetchPerformanceDataSuccess,
//   fetchPerformanceDataFailure,
//   fetchRecommendationDataInit,
// } from "../slices/agentHomeSlice";
// import { recommendations } from "../../db";
// import { AgentDummyData } from "../../agent/pages/AgentHome/AgentDummyjson";

// function* fetchRecommendationsSaga() {
//   try {
//     const data = yield call(() => Promise.resolve(recommendations));
//     yield put(fetchRecommendationsSuccess(data));
//   } catch (error) {
//     yield put(fetchRecommendationsFailure(error.message));
//   }
// }

// function* getPerformanceData(action) {
//   try {
//     yield put(fetchPerformanceDataSuccess(AgentDummyData[action.payload]));

//   } catch (error) {
//     console.log(" wrong data will fetch ");
//   }
// }

// export function* watchAgentHomeData() {
//   yield takeLatest(fetchRecommendationsStart.type, fetchRecommendationsSaga);
//   yield takeLatest(fetchRecommendationDataInit.type, fetchRecommendationsSaga);
//   yield takeLatest(fetchPerformanceDataInit.type, getPerformanceData);
// }

// import { call, put, takeLatest } from "redux-saga/effects";
// import {
//   fetchRecommendationsStart,
//   fetchRecommendationsSuccess,
//   fetchRecommendationsFailure,
//   fetchPerformanceDataInit,
//   fetchPerformanceDataSuccess,
//   fetchPerformanceDataFailure,
//   fetchRecommendationDataInit,
//   getPerformanceDataInit,
//   fetchInteractionInit,
//   fetchInteractionSuccess,
//   fetchInteractionFailure,
// } from "../slices/agentHomeSlice";
// import { recommendations,processImprovement } from "../../db";
// import { AgentDummyData } from "../../agent/pages/AgentHome/AgentDummyjson";
// function* fetchRecommendationsSaga(action) {
//   try {
//     const recommendationsData = yield call(() => Promise.resolve(recommendations[action.payload]));
//     const processImprovementData = yield call(() => Promise.resolve(processImprovement[action.payload]));
//     const data = {
//       recommendations : recommendationsData,
//       processImprovement : processImprovementData
//     }
//     yield put(fetchRecommendationsSuccess(data));
//   } catch (error) {
//     yield put(fetchRecommendationsFailure(error.message));
//   }
// }

// function* getPerformanceData(action) {
//   try {
//     const data = yield call(() => Promise.resolve(AgentDummyData[action.payload]));
//     yield put(fetchPerformanceDataSuccess(data));
//     // yield put(fetchPerformanceDataSuccess(AgentDummyData[action.payload]));
//   } catch (error) {
//     yield put(fetchPerformanceDataFailure(error.message));
//   }
// }

// // Simulated API call function
// function fetchInteractionAPI(question) {
//   return Promise.resolve({ response: `View on The Spot Analysis Response here : ${question}` }); // Replace with actual API call
// }

// function* fetchInteractionSaga(action) {
//   try {
//     const response = yield call(fetchInteractionAPI, action.payload);
//     yield put(fetchInteractionSuccess(response.response)); // Send the response to Redux state
//   } catch (error) {
//     yield put(fetchInteractionFailure(error.message)); // Send the error message to Redux state
//   }
// }

// export function* watchAgentHomeData() {
//   yield takeLatest(fetchRecommendationsStart.type, fetchRecommendationsSaga);
//   // yield takeLatest(fetchRecommendationDataInit.type, fetchRecommendationsSaga);
//   yield takeLatest(fetchPerformanceDataInit.type, getPerformanceData);
//   yield takeLatest(fetchInteractionInit.type, fetchInteractionSaga);
// }

import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchRecommendationsStart,
  fetchRecommendationsSuccess,
  fetchRecommendationsFailure,
  fetchPerformanceDataInit,
  fetchPerformanceDataSuccess,
  fetchPerformanceDataFailure,
  fetchRecommendationDataInit,
  getPerformanceDataInit,
  fetchInteractionInit,
  fetchInteractionSuccess,
  fetchInteractionFailure,
  setLoading,
  fetchTransactionDetailsInit,
  fetchTransactionDetailsSuccess,
  fetchTransactionDetailsFailure,
} from "../slices/agentHomeSlice";
import { recommendations, processImprovement } from "../../db";
import { AgentDummyData } from "../../agent/pages/AgentHome/AgentDummyjson";
import { postAgentPortalDataAPI } from "../../operations/services/getAgentPortal";
import {
  getAgentImprovementAPI,
  getProcessImprovementAPI,
} from "../../operations/services/getAgentPortal";
import { postTransactionDetailsApi } from "../../operations/services/getAgentPortal";
import { notify } from "../../common/Helper/notification";

function* fetchRecommendationsSaga(action) {
  try {
    yield(setLoading(true));
    console.log("agent improvement call: ", action.payload);
    const recommendationsData = yield call(() =>
      Promise.resolve(getAgentImprovementAPI(action.payload))
    );
    const processImprovementData = yield call(() =>
      Promise.resolve(getProcessImprovementAPI(action.payload))
    );
    const data = {
      recommendations: recommendationsData,
      processImprovement: processImprovementData,
    };
    console.log("agent improvement finished: ", data);
    console.log("hiiiii",recommendationsData);
    yield put(fetchRecommendationsSuccess(data));
  } catch (error) {
    console.log("agent improvement error: ", error);
    yield put(fetchRecommendationsFailure(error.message));
  }
}

// function* getPerformanceData(action) {
//   try {
//     const data = yield call(() => Promise.resolve(AgentDummyData[action.payload]));
//     yield put(fetchPerformanceDataSuccess(data));
//     // yield put(fetchPerformanceDataSuccess(AgentDummyData[action.payload]));
//   } catch (error) {
//     yield put(fetchPerformanceDataFailure(error.message));
//   }
// }

function* getPerformanceData(action) {
  try {
    console.log(action.payload);
    const baseUrl =
      "https://contact-center-plus.azurewebsites.net/api/AgentInsightDetails?code=IK7UP_OgAZBDo-mT7Bw-zNuwNmtXYkb6MqT99nt3YqhTAzFuH3lDiw%3D%3D";
    // console.log(baseUrl);
    console.log("Calling API...");
    // yield put(setLoading(true));
    // const data = yield call(() => Promise.resolve(postRequest(baseUrl , payload)));
    const data = yield call(() =>
      Promise.resolve(postAgentPortalDataAPI(action.payload))
    );
    console.log(data);
    yield put(fetchPerformanceDataSuccess(data[0]));

    console.log(data.data);
    // yield put(fetchPerformanceDataSuccess(AgentDummyData[action.payload]));
  } catch (error) {
    console.error("Error in getPerformanceData saga:", error);
    // notify.error("No data found for this agent");
    yield put(fetchPerformanceDataFailure(error.message));
  }
}

// Simulated API call function
function fetchInteractionAPI(question) {
  return Promise.resolve({
    response: `View on The Spot Analysis Response here : ${question}`,
  }); // Replace with actual API call
}

function* fetchInteractionSaga(action) {
  try {
    const response = yield call(fetchInteractionAPI, action.payload);
    yield put(fetchInteractionSuccess(response.response)); // Send the response to Redux state
  } catch (error) {
    yield put(fetchInteractionFailure(error.message)); // Send the error message to Redux state
  }
}

function* fetchTransactionDetailsSaga(action) {
  try {
    console.log("Payload sent to API:", action.payload);
    const data = yield call(postTransactionDetailsApi, action.payload); // Correct usage of call
    console.log("Data received from API:", data);
    // Dispatch success action with the received data
    yield put(fetchTransactionDetailsSuccess(data));
  } catch (error) {
    console.error("Error in fetchTransactionDetailsSaga:", error);
    yield put(fetchTransactionDetailsFailure(error.message));
  }
}

export function* watchAgentHomeData() {
  yield takeLatest(fetchRecommendationsStart.type, fetchRecommendationsSaga);
  // yield takeLatest(fetchRecommendationDataInit.type, fetchRecommendationsSaga);
  yield takeLatest(fetchPerformanceDataInit.type, getPerformanceData);
  yield takeLatest(fetchInteractionInit.type, fetchInteractionSaga);
  yield takeLatest(
    fetchTransactionDetailsInit.type,
    fetchTransactionDetailsSaga
  );
}
